var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "scrollWindow",
      staticClass: "vue-scroll-window",
      on: {
        touchstart: function($event) {
          $event.stopPropagation()
          return _vm.startMove($event)
        }
      }
    },
    [
      _c(
        "div",
        {
          ref: "scrollContent",
          staticClass: "vue-scroll-body",
          class: { "vue-scroll-animation": _vm.animation },
          style: {
            marginTop: _vm.scrollTop + "px",
            marginLeft: _vm.scrollLeft + "px"
          }
        },
        [_vm._t("default")],
        2
      ),
      _c("resize-observer", { on: { notify: _vm.handleResize } }),
      _c("transition", { attrs: { name: "vue-scroll" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showScrollY,
                expression: "showScrollY"
              }
            ],
            staticClass: "vue-scroll-track left-track",
            style: [_vm.scrollTrackYStyle || _vm.scrollTrackStyle],
            on: {
              click: function($event) {
                $event.stopPropagation()
                return (function(e) {
                  _vm.clickTo(e, "y")
                })($event)
              }
            }
          },
          [
            _c("button", {
              staticClass: "vue-scroll-bar left-bar",
              class: { "vue-scroll-animation": !_vm.moveY },
              style: [
                {
                  marginTop: _vm.top + "px",
                  height: _vm.height + "px"
                },
                _vm.scrollBarYStyle || _vm.scrollBarStyle
              ],
              on: {
                mousedown: function($event) {
                  $event.stopPropagation()
                  return _vm.startMoveY($event)
                }
              }
            })
          ]
        )
      ]),
      _c("transition", { attrs: { name: "vue-scroll" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showScrollX,
                expression: "showScrollX"
              }
            ],
            staticClass: "vue-scroll-track bottom-track",
            style: [_vm.scrollTrackXStyle || _vm.scrollTrackStyle],
            on: {
              click: function($event) {
                $event.stopPropagation()
                return (function(e) {
                  _vm.clickTo(e, "x")
                })($event)
              }
            }
          },
          [
            _c("button", {
              staticClass: "vue-scroll-bar bottom-bar",
              class: { "vue-scroll-animation": !_vm.moveX },
              style: [
                {
                  marginLeft: _vm.left + "px",
                  width: _vm.width + "px"
                },
                _vm.scrollBarXStyle || _vm.scrollBarStyle
              ],
              on: {
                mousedown: function($event) {
                  $event.stopPropagation()
                  return _vm.startMoveX($event)
                }
              }
            })
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-034cda30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-034cda30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/scroll-bar/src/main.vue
// module id = 4zmS
// module chunks = 28